import React from "react";
import ResourceListPage from "components/ResourceListPage";

const Books = () => <ResourceListPage resource="books" title="Book" />;

export default Books;
